import {Component, OnInit} from '@angular/core';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {ButtonComponent} from '../shared/components/button/button.component';
import {LoginInfo} from '../shared/model/loginInfo.model';
import {ActivatedRoute, Router} from '@angular/router';
import {MsgServiceService} from '../shared/service/msg-service.service';
import {AuthServiceService} from '../shared/service/auth-service.service';
import {ConstantsUtils} from '../shared/util/constants.utils';
import * as CryptoJS from 'crypto-js';


@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  imports: [FormFieldComponent, ButtonComponent],
  providers: [AuthServiceService]
})
export class LoginComponent implements OnInit {
  login: LoginInfo = new LoginInfo();

  constructor(
    private msgService: MsgServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthServiceService) { }

  ngOnInit() {
  }

  logar() {
    if (this.validarLogin()) {
      this.autenticar()
    }
  }

  validarLogin() {
    const email = this.login.email?.trim();
    if (!email) {
      this.msgService.msgAdvertencia('Digite um email');
      return false;
    }
    if (!email.includes('@')) {
      this.msgService.msgAdvertencia('Digite um e-mail válido.');
      return false;
    }
    if (!this.login.senha?.trim()) {
      this.msgService.msgAdvertencia('Informe uma senha');
      return false;
    }
    return true;
  }

  autenticar() {
    this.authService.login(this.login).subscribe({
      next: (response: any) => {
        if (response && response.token) {
          this.authService.armazenarToken(response.token);
          localStorage.setItem('permissoesParceiros', CryptoJS.AES.encrypt(JSON.stringify(response.usuario), ConstantsUtils.SECRET_KEY).toString());
          localStorage.setItem('parceiro', JSON.stringify(response.usuario));
          this.router.navigate(['/index']);
        }
      },
      error: (error) => {
        this.msgService.msgErro(error.error);
      }
    })
  }

  verificarPermissoes(){
    this.route.queryParams.subscribe({
      next: res => {
        if(res['token'] && res['token'] !== localStorage.getItem('tokenParceiro')) {
          this.authService.armazenarToken(res['token']);
          this.router.navigate(['index']);
        } else if (localStorage.getItem('permissoesParceiros')) {
          this.router.navigate([`index`]);
        }
      }
    });
  }
}
